import { render, staticRenderFns } from "./showScore-editor.vue?vue&type=template&id=66e67094&scoped=true"
import script from "./showScore-editor.vue?vue&type=script&lang=js"
export * from "./showScore-editor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66e67094",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('66e67094')) {
      api.createRecord('66e67094', component.options)
    } else {
      api.reload('66e67094', component.options)
    }
    module.hot.accept("./showScore-editor.vue?vue&type=template&id=66e67094&scoped=true", function () {
      api.rerender('66e67094', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form-designer/setting-panel/property-editor/field-rate/showScore-editor.vue"
export default component.exports